export class EquityPercentage {

    constructor($scope, $log, $filter) {
        this.$scope = $scope;
        this.$log = $log;
        this.$filter = $filter;
    }


    $onInit = () => {
        let parameter = this.parameter;
        let equityPercentage = this.$filter('number')(parameter.bigDecimalValue, 2);
        this.$scope.equity = equityPercentage ? equityPercentage + '%' : '';
    };

    static instance = {
        controller: ['$scope', '$log', '$filter', EquityPercentage],
        template: require('./equityPercentage.html'),
        bindings: {
            parameter: '<'
        }
    }
}
